import React, {memo, useEffect, useMemo, useRef} from "react";
import {PDFViewer} from "@react-pdf/renderer";

import {useDebounce, useWindowSize} from "../Hooks";
import {getLabelConfig, getPageOrientation} from "../Utils";
import {useAppStore} from "../Stores";

export const Preview: React.FC = memo(() => {
  const labelType = useAppStore.use.labelType();
  const config = getLabelConfig(labelType);

  if (!config) {
    throw new Error('Impossible de récupérer la configuration du type d\'étiquette ' + labelType + '.');
  }
  const PdfComponent = config.components.pdf;

  const labels = useAppStore.use.labels();
  const printOptions = useAppStore.use.printOptions();

  if (!printOptions) {
    throw new Error('Impossible de récupérer les options d\'impression.');
  }

  const [windowWidth] = useWindowSize();
  const iframeRef = useRef<any>();
  const debouncedWindowWidth = useDebounce(windowWidth, 500);

  const ratio = useMemo(() => getPageOrientation(printOptions.size, printOptions.orientation) === 'portrait'
    ? 0.70707070707
    : 1.41428571429, [printOptions.size, printOptions.orientation]);

  // Resize iframe height
  useEffect(() => {
    if (!iframeRef.current) return;

    const iframe = iframeRef.current.querySelector('iframe');
    if (iframe) {
      const height = Math.ceil((iframeRef.current.offsetWidth - 40) / ratio);
      iframe.style.height = `${height}px`;
    }
  }, [debouncedWindowWidth, printOptions.size, printOptions.orientation]);

  return (
    <div className="card" ref={iframeRef}>
      <h1>Aperçu</h1>

      <PDFViewer showToolbar={false} width="100%">
        <PdfComponent printOptions={printOptions} labels={labels} />
      </PDFViewer>
    </div>
  );
});

export default Preview;
